<template>
  <div class="out">
    <div class="" style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0;position: relative;height:800px;margin-top:-110px">
      <iframe src="https://www.kingdee.com/products/cosmic.html" style="z:index: 0;position: absolute; top: 20px; left: 0px;" width="100%" height="800" class="shop-dashboard-homepage__iframe"/>
    </div>
    <CircleBtn @back="back" />
  </div>
</template>

<script>
import CircleBtn from '@/components/CircleBtn.vue'

export default {
  name: 'Cosmic',
  components: { CircleBtn },
  data() {
    return {
    }
  },

  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>>



// WEBPACK FOOTER //
// src/components/CosmicPlatform.vue